export const environment = {
	production: true,
	url: 'https://api.dev-carrier.kosaas-mmi.com:3001'
};
